import { putRequest } from "../httpMethods";

export const putBoard = (id, payload) => putRequest(`v1/sv/masters/board/${id}`, payload);
export const putMedium = (id, payload) => putRequest(`v1/sv/masters/medium/${id}`, payload);
export const putGrade = (id, payload) => putRequest(`v1/sv/masters/grade/${id}`, payload);
export const putSection = (id, payload) => putRequest(`v1/section/${id}`, payload);
